import { Component, createRef } from 'react';

import style from './progress.component.module.scss';
import { OptionalChildrenProps } from '../../../types/react.types';


interface ProgressProps extends OptionalChildrenProps {
    value?: number;
    max?: number;
    min?: number;
    numberOfDecimals?: number;
    postFix?: string;
    preFix?: string;
    type?: 'warning' | 'primary' | 'danger' | 'info';
}

interface ProgressState {
    value: number;
}

/**
 * Component updated by outside only
 */
export default class ProgressComponent extends Component<ProgressProps, ProgressState> {
    container = createRef<HTMLDivElement>();
    handler: ((e: MouseEvent) => void) | null = null;
    eventOffset = 0;
    max = 100;
    min = 0;

    valueFormatter = (val) => {
        const parsedVal = val.toFixed(this.props.numberOfDecimals || 2);
        return `${this.props.preFix || ''} ${Number(parsedVal)} ${this.props.postFix || ''}`.trim();
    };

    readonly state: Readonly<ProgressState> = {
        value: this.props?.value ?? 0,
    };
    constructor(props: ProgressProps) {
        super(props);
        this.max = this.props.max || 100;
        this.min = this.props.min || 0;
    }

    computeRailPosition(props) {
        return ((props.value || 0) / (this.max - this.min)) * 100;
    }

    render() {
        const value = this.computeRailPosition(this.props);
        return (
            <div ref={this.container} className={style.container}>
                <div className={style['range-selector']}>
                    <div className={style.rail}>
                        <div className={`${style.handler}`} style={{ width: `${value}%` }}></div>
                        <div className={style.overlay} style={{ width: `100%` }}>{this.valueFormatter(value)}</div>
                    </div>
                </div>
            </div>
        );
    }
}